import { Directive, ElementRef, Optional, Input, HostListener, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import Cleave from 'cleave.js';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
class NgxCleaveDirective {
    /**
     * @param {?} elementRef
     * @param {?} ngControl
     */
    constructor(elementRef, ngControl) {
        this.elementRef = elementRef;
        this.ngControl = ngControl;
    }
    /**
     * @param {?} cleave
     * @return {?}
     */
    set cleave(cleave) {
        this._cleave = cleave;
        this.setCleave();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.ngControl) {
            console.warn('Note: The cleave directive should be used with the ngModel, formControl or formControlName directives.');
            return;
        }
        this._valueAccessor = this.ngControl.valueAccessor;
        this._writeValue = this._valueAccessor.writeValue;
        this._valueAccessor.writeValue = (/**
         * @param {?} value
         * @return {?}
         */
        (value) => {
            if (this._writeValue) {
                this._writeValue.call(this._valueAccessor, value);
            }
            this.setCleave();
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this._valueAccessor && this._writeValue) {
            this._valueAccessor.writeValue = this._writeValue;
        }
        if (this._cleaveInstance) {
            this._cleaveInstance.destroy();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onInput(value) {
        this._value = value;
    }
    /**
     * @private
     * @return {?}
     */
    setCleave() {
        if (this._cleaveInstance) {
            this._cleaveInstance.destroy();
        }
        /** @type {?} */
        const el = this.elementRef.nativeElement;
        this._cleaveInstance = new Cleave(el, Object.assign({}, this._cleave, { onValueChanged: (/**
             * @param {?} __0
             * @return {?}
             */
            ({ target }) => {
                if (target.value !== this._value) {
                    this.dispatchEvent(el, 'input');
                }
                if (this._cleave.onValueChanged && typeof this._cleave.onValueChanged === 'function') {
                    this._cleave.onValueChanged({ target });
                }
            }) }));
        // hack for model -> view cleave
        setTimeout((/**
         * @return {?}
         */
        () => this.dispatchEvent(el, 'input')), 0);
    }
    /**
     * @private
     * @param {?} el
     * @param {?} eventType
     * @return {?}
     */
    dispatchEvent(el, eventType) {
        /** @type {?} */
        const event = document.createEvent('Event');
        event.initEvent(eventType, false, false);
        el.dispatchEvent(event);
    }
}
NgxCleaveDirective.ɵfac = function NgxCleaveDirective_Factory(t) { return new (t || NgxCleaveDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 8)); };
NgxCleaveDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxCleaveDirective, selectors: [["input", "cleave", ""], ["textarea", "cleave", ""]], hostBindings: function NgxCleaveDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function NgxCleaveDirective_input_HostBindingHandler($event) { return ctx.onInput($event.target.value); });
    } }, inputs: { cleave: "cleave" } });
/** @nocollapse */
NgxCleaveDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgControl, decorators: [{ type: Optional }] }
];
NgxCleaveDirective.propDecorators = {
    cleave: [{ type: Input }],
    onInput: [{ type: HostListener, args: ['input', ['$event.target.value'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCleaveDirective, [{
        type: Directive,
        args: [{
                selector: 'input[cleave],textarea[cleave]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }] }]; }, { cleave: [{
            type: Input
        }], 
    /**
     * @param {?} value
     * @return {?}
     */
    onInput: [{
            type: HostListener,
            args: ['input', ['$event.target.value']]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxCleaveDirectiveModule {
}
NgxCleaveDirectiveModule.ɵfac = function NgxCleaveDirectiveModule_Factory(t) { return new (t || NgxCleaveDirectiveModule)(); };
NgxCleaveDirectiveModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxCleaveDirectiveModule });
NgxCleaveDirectiveModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCleaveDirectiveModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [NgxCleaveDirective],
                exports: [NgxCleaveDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxCleaveDirectiveModule, { declarations: [NgxCleaveDirective], exports: [NgxCleaveDirective] }); })();

export { NgxCleaveDirective, NgxCleaveDirectiveModule };

